/* eslint-disable jsx-a11y/label-has-for */
import React, { useEffect, useRef, useState } from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";
import InputMask from "react-input-mask";
import { COUNTRIES } from "../../../constants/countries";
import { STATES } from "../../../constants/States";
import { FORM_ID } from "../../../constants/Forms";
import Moment from "moment";
import LostDataModal from "../../SharedComponents/LostDataModal";
import EducationRequirementsModal from "../Forms/EducationRequirementsModal";
import {
  updateCandidateEducation,
  updateInternEducation,
  insertCandidateEducation,
  insertInternEducation,
  // deleteInternEducation,
  // deleteCandidateEducation,
} from "../../../api/makeAPIRequest";
import { clickFunc, isValidDate } from "../../../common/Functions";
import { CONTRACT_TYPE_DESCRIPTIONS } from "../../../constants/Contract";
import NavigationButtons from "../../SharedComponents/NavigationButtons";
import { UtagTracking } from "../../../utils/utag-tracking";
import InstitutionModal from "./InstitutionModal";
import InstitutionHistoryTable from "./InstitutionHistoryTable";
import { collect } from "underscore";

const EducationForm = (props) => {
  const [formHasError, setFormHasError] = useState(false);
  const [formHasChanged, setFormHasChanged] = useState(false);
  const [highestEducation, setHighestEducation] = useState("");
  const [highestEducationId, setHighestEducationId] = useState("");
  const [degree, setDegree] = useState("");
  const [degreeId, setDegreeId] = useState("");
  const [institutionName, setInstitutionName] = useState("");
  const [majorIn, setMajorIn] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [cntrlWithFocus, setCntrlWithFocus] = useState("");
  const [showBackModal, setShowBackModal] = useState(false);
  const [showEduReqModal, setShowEduReqModal] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [currEnrolled, setCurrEnrolled] = useState("");
  const [yearEnrolled, setYearEnrolled] = useState("");
  const [overallGpa, setOverallGpa] = useState("");
  const [majorGpa, setMajorGpa] = useState("");
  const [disableMajorIn, setDisableMajorIn] = useState(false);
  const [showState, setShowState] = useState(false);
  const [DEGREES, setDEGREES] = useState([]);
  const [EDUCATIONLEVEL, setEDUCATIONLEVEL] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showAddInstitutionModal, setShowAddInstitutionModal] = useState(false);
  const [attendedCollege, setAttendedCollege] = useState("");
  const [institutionsAttended, setInstitutionsAttended] = useState([]);
  const [isReviewEditInstitution, setIsReviewEditInstitution] = useState(false);
  const [editInstitutionDetails, setEditInstitutionDetails] = useState([]);
  const [isBackClicked, setIsBackClicked] = useState(false);
  const prevAttendedCollege = useRef(attendedCollege);

  var hasError = false;
  var hasChange = false;

  const isCollegeUser = () => {
    return props.contracttypedesc === CONTRACT_TYPE_DESCRIPTIONS.COLLEGE_INTERN;
  };

  const isCareerUser = () => {
    return (
      props.contracttypedesc === CONTRACT_TYPE_DESCRIPTIONS.CAREER_AGENT ||
      props.contracttypedesc === CONTRACT_TYPE_DESCRIPTIONS.CAREER_SAMPLING ||
      props.contracttypedesc === CONTRACT_TYPE_DESCRIPTIONS.ALTERNATE_AGENT ||
      props.contracttypedesc === CONTRACT_TYPE_DESCRIPTIONS.MMLIS ||
      props.contracttypedesc === CONTRACT_TYPE_DESCRIPTIONS.AGENT_EMERITUS ||
      props.contracttypedesc === CONTRACT_TYPE_DESCRIPTIONS.CRIA_ONLY ||
      props.contracttypedesc ===
        CONTRACT_TYPE_DESCRIPTIONS.INVESTMENT_ADVISOR ||
      props.contracttypedesc === CONTRACT_TYPE_DESCRIPTIONS.PRELIMINARY
    );
  };

  const onBlur = async (event) => {
    let obj_error;

    if (
      cntrlWithFocus.includes("option") &&
      cntrlWithFocus !== event.target.id
    ) {
    } else {
      if (event.target.id.includes("education_id")) {
        obj_error = document.getElementById("education_error");

        if (event.target.innerText.trim(" ").length === 0) {
          event.target.style.border = "1.5px solid #e21224";
          event.target.style.border = "1.5px solid #e21224";
          obj_error.style.display = "block";
          hasError = true;
        } else {
          obj_error.style.display = "none";
          var educationCtrl = document.getElementById(event.target.id);
          if (event.target.className !== "dropdown-item") {
            event.target.removeAttribute("style");
          } else {
            educationCtrl.style.border = "1.5px solid #6b748e";
          }
        }
      }
      if (
        event.target.id.includes("education_option") &&
        cntrlWithFocus !== "education_option"
      ) {
        obj_error = document.getElementById("education_error");
        let ctrlToValidate = document.getElementById("education_id");
        if (highestEducation.length === 0) {
          ctrlToValidate.style.border = "1.5px solid #e21224";
          obj_error.style.display = "block";
          hasError = true;
        } else {
          obj_error.style.display = "none";
          if (ctrlToValidate.className !== "dropdown-item") {
            ctrlToValidate.removeAttribute("style");
          } else {
            let genderCtrl2 = document.getElementById("gender_id");
            genderCtrl2.style.border = "1.5px solid #6b748e";
          }
        }
      }
      if (event.target.id.includes("degree_name")) {
        obj_error = document.getElementById("degree_name_error");

        if (event.target.innerText.trim(" ").length === 0) {
          event.target.style.border = "1.5px solid #e21224";
          obj_error.style.display = "block";
          hasError = true;
        } else {
          obj_error.style.display = "none";
          if (event.target.className !== "dropdown-item") {
            event.target.removeAttribute("style");
          } else {
            let educationCtrl = document.getElementById(event.target.id);
            educationCtrl.style.border = "1.5px solid #6b748e";
          }
        }
      }
      if (
        event.target.id.includes("degree_option") &&
        cntrlWithFocus !== "degree_option"
      ) {
        obj_error = document.getElementById("degree_name_error");
        let ctrlToValidate = document.getElementById("degree_name");
        if (degree.length === 0) {
          ctrlToValidate.style.border = "1.5px solid #e21224";
          obj_error.style.display = "block";
          hasError = true;
        } else {
          obj_error.style.display = "none";
          if (ctrlToValidate.className !== "dropdown-item") {
            ctrlToValidate.removeAttribute("style");
          } else {
            let genderCtrl2 = document.getElementById("degree_name");
            genderCtrl2.style.border = "1.5px solid #6b748e";
          }
        }
      }
      if (event.target.id.includes("institution_name")) {
        obj_error = document.getElementById("institution_name_error");
        if (
          event.target.value.trim(" ").length < 3 ||
          institutionName.length < 3
        ) {
          event.target.style.color = "#e21224";
          event.target.style.border = "1.5px solid #e21224";
          obj_error.style.display = "block";
          hasError = true;
        } else {
          event.target.style.color = "#6b748e";
          obj_error.style.display = "none";
          event.target.removeAttribute("style");
        }
      }
      if (event.target.id.includes("major_in")) {
        obj_error = document.getElementById("major_in_error");
        if (event.target.value.trim(" ").length < 3 || majorIn.length < 3) {
          event.target.style.border = "1.5px solid #e21224";
          event.target.style.color = "#e21224";
          obj_error.style.display = "block";
          hasError = true;
        } else {
          obj_error.style.display = "none";
          event.target.removeAttribute("style");
        }
      }
      if (event.target.id.includes("city")) {
        obj_error = document.getElementById("city_error");
        if (event.target.value.trim(" ").length < 2 || city.length < 2) {
          event.target.style.border = "1.5px solid #e21224";
          obj_error.style.display = "block";
          event.target.style.color = "#e21224";
          hasError = true;
        } else {
          obj_error.style.display = "none";
          event.target.removeAttribute("style");
          event.target.style.color = "#555";
        }
      }
      if (event.target.id.includes("state_id") && showState === true) {
        obj_error = document.getElementById("state_id_error");
        let obj_err = document.getElementById("state_id_opt");

        if (event.target.innerText.trim("").length === 0) {
          obj_err.style.border = "1.5px solid #e21224";
          obj_error.style.display = "block";
          hasError = true;
        } else {
          obj_error.style.display = "none";
          if (event.target.className !== "dropdown-item") {
            obj_err.removeAttribute("style");
          } else {
            let educationCtrl = document.getElementById(event.target.id);
            educationCtrl.style.border = "1.5px solid #6b748e";
          }
        }
      }
      if (
        showState === true &&
        event.target.id.includes("state_option") &&
        cntrlWithFocus !== "state_option"
      ) {
        obj_error = document.getElementById("state_id_error");
        let ctrlToValidate = document.getElementById("state_id_opt");
        if (state.length === 0) {
          ctrlToValidate.style.border = "1.5px solid #e21224";
          obj_error.style.display = "block";
          hasError = true;
        } else {
          obj_error.style.display = "none";
          if (ctrlToValidate.className !== "dropdown-item") {
            ctrlToValidate.removeAttribute("style");
          } else {
            let genderCtrl2 = document.getElementById("state_id_opt");
            genderCtrl2.style.border = "1.5px solid #6b748e";
            genderCtrl2.style.border = "1.5px solid #6b748e";
          }
        }
      }
      if (event.target.id.includes("country_id")) {
        obj_error = document.getElementById("country_id_error");

        if (event.target.innerText.trim(" ").length === 0) {
          event.target.style.border = "1.5px solid #e21224";
          event.target.style.border = "1.5px solid #e21224";
          obj_error.style.display = "block";
          hasError = true;
        } else {
          obj_error.style.display = "none";
          if (event.target.className !== "dropdown-item") {
            event.target.removeAttribute("style");
          } else {
            let educationCtrl = document.getElementById(event.target.id);
            educationCtrl.style.border = "1.5px solid #6b748e";
            educationCtrl.style.border = "1.5px solid #6b748e";
          }
        }
      }
      if (event.target.id.includes("overallGpa")) {
        obj_error = document.getElementById("overallGpaError");
        let gpaVal = event.target.value.replace(/_/g, "");
        if (
          gpaVal.trim(" ").length < 3 ||
          overallGpa.trim(" ").length < 3 ||
          gpaVal > 5
        ) {
          event.target.style.color = "#e21224";
          event.target.style.border = "1.5px solid #e21224";
          event.target.style.border = "1.5px solid #e21224";
          obj_error.style.display = "block";
          hasError = true;
        } else {
          event.target.style.color = "#6b748e";
          obj_error.style.display = "none";
          event.target.removeAttribute("style");
        }
      }
      if (event.target.id.includes("majorGpa")) {
        obj_error = document.getElementById("majorGpaError");
        let gpaVal = event.target.value.replace(/_/g, "");
        if (
          gpaVal.trim().length < 3 ||
          majorGpa.trim().length < 3 ||
          gpaVal > 5
        ) {
          event.target.style.color = "#e21224";
          event.target.style.border = "1.5px solid #e21224";
          event.target.style.border = "1.5px solid #e21224";
          obj_error.style.display = "block";
          hasError = true;
        } else {
          event.target.style.color = "#6b748e";
          obj_error.style.display = "none";
          event.target.removeAttribute("style");
        }
      }
      if (event.target.id.includes("_date")) {
        let date = new Moment();
        let start_date =
          startDate === "" ? "" : new Moment(startDate, "MM/YYYY");
        let end_date = endDate === "" ? "" : new Moment(endDate, "MM/YYYY");

        if (event.target.id === "start_date") {
          var error;
          error = document.getElementById("start_date_error");
          let currDate3 = Moment();
          let dateParts3 = event.target.value.split("/");
          let month3 = dateParts3[0];
          let year3 = dateParts3[1];
          let dateCalc3 = Moment(year3 + "-" + month3);
          let yearDiff3 = currDate3.diff(dateCalc3, "year");

          if (
            event.target.value.includes("_") ||
            event.target.value === "" ||
            !isValidDate(event.target.value) ||
            event.target.value.includes("0000")
          ) {
            event.target.style.border = "1.5px solid #e21224";
            event.target.style.border = "1.5px solid #e21224";
            error.style.display = "block";
            error.innerText = "Please enter a Start Date";
            event.target.style.color = "#e21224";
            hasError = true;
            hasError = true;
          } else if (dateCalc3 > currDate3 || start_date.isAfter(date)) {
            event.target.style.border = "1.5px solid #e21224";
            event.target.style.border = "1.5px solid #e21224";
            error.innerText = "Start Date cannot be a future date";
            error.style.display = "block";
            event.target.style.color = "#e21224";
            hasError = true;
          } else if (yearDiff3 >= 80) {
            event.target.style.border = "1.5px solid #e21224";
            event.target.style.border = "1.5px solid #e21224";
            error.innerText = "Start Date cannot be more than 80 years ago";
            error.style.display = "block";
            event.target.style.color = "#e21224";
            hasError = true;
          } else if (end_date !== "" && start_date.isAfter(end_date)) {
            error.innerText = "Start Date cannot be after End Date";
            event.target.style.border = "1.5px solid #e21224";
            event.target.style.border = "1.5px solid #e21224";
            error.style.display = "block";
            event.target.style.color = "#e21224";
            hasError = true;
          } else {
            error.style.display = "none";
            event.target.removeAttribute("style");
            event.target.style.color = "#555";
            let end_date_error = document.getElementById("end_date_error");
            if (end_date_error.style.display === "block") {
              // run onblur for start_date
              let end_date_error = new Event("blur");
              Object.defineProperty(end_date_error, "target", {
                writable: false,
                value: document.getElementById("end_date"),
              });

              onBlur(end_date_error);
            }
          }
        }
        if (event.target.id === "end_date") {
          var obj_error2;
          let currDate3 = Moment();
          let dateParts3 = event.target.value.split("/");
          let month3 = dateParts3[0];
          let year3 = dateParts3[1];
          let dateCalc3 = Moment(year3 + "-" + month3);
          let pls3yrs = Moment().add(3, "years").subtract(1, "months");
          obj_error2 = document.getElementById("end_date_error");
          let yearDiff3 = currDate3.diff(dateCalc3, "year");
          if (
            event.target.value.includes("_") ||
            event.target.value === "" ||
            !isValidDate(event.target.value) ||
            event.target.value.includes("0000")
          ) {
            event.target.style.border = "1.5px solid #e21224";
            event.target.style.border = "1.5px solid #e21224";
            obj_error2.style.display = "block";
            obj_error2.innerText = "Please enter an End Date";
            event.target.style.color = "#e21224";
            hasError = true;
          } else if (yearDiff3 >= 80) {
            event.target.style.border = "1.5px solid #e21224";
            obj_error2.innerText = "End Date cannot be more than 80 years ago";
            obj_error2.style.display = "block";
            event.target.style.color = "#e21224";
            hasError = true;
          } else if (start_date !== "" && start_date.isAfter(end_date)) {
            obj_error2.innerText = "End Date cannot be before Start Date";
            event.target.style.border = "1.5px solid #e21224";
            event.target.style.border = "1.5px solid #e21224";
            obj_error2.style.display = "block";
            event.target.style.color = "#e21224";
            hasError = true;
          } else if (dateCalc3 > pls3yrs) {
            event.target.style.border = "1.5px solid #e21224";
            event.target.style.border = "1.5px solid #e21224";
            obj_error2.innerText =
              "End Date can be a date no more than 3 years from now";
            obj_error2.style.display = "block";
            event.target.style.color = "#e21224";
            hasError = true;
          } else {
            obj_error2.style.display = "none";
            event.target.removeAttribute("style");
            event.target.style.color = "#555";

            let start_date_error = document.getElementById("start_date_error");
            if (start_date_error.style.display === "block") {
              // run onblur for start_date
              var startdateEvent = new Event("blur");
              Object.defineProperty(startdateEvent, "target", {
                writable: false,
                value: document.getElementById("start_date"),
              });

              onBlur(startdateEvent);
            }
          }
        }
      }
    }
    if (hasError) {
      setFormHasError(true);
    } else {
      setFormHasError(false);
      hasError = false;
    }
  };

  const handleCloseBackModal = () => {
    setShowBackModal(false);
    if (
      attendedCollege === "No" &&
      prevAttendedCollege.current === "Yes" &&
      !isBackClicked
    ) {
      setAttendedCollege("Yes");
      props.hasCurrentFormChanged(false);
      props.isFormComplete(true);
    }
  };

  const handleLostDataProceed = async () => {
    if (attendedCollege === "Yes") {
      if (isCollegeUser()) {
        let collegeInstitute = institutionsAttended.filter((instAtt) => {
          return instAtt.interneducationhistoryid;
        });
        if (collegeInstitute.length > 0) {
          setAttendedCollege("YES");
          props.saveInternEduInfo(collegeInstitute);
        } else {
          props.saveInternEduInfo([]);
          setAttendedCollege("");
        }
      }

      let updatedInstitute = institutionsAttended.filter(
        (instAtt) => instAtt.educationHistoryId || instAtt.educationhistoryid,
      );

      if (updatedInstitute.length > 0) {
        setAttendedCollege("YES");
        props.saveEduInfo(updatedInstitute);
      } else {
        props.saveEduInfo([]);
        setAttendedCollege("");
      }
    }
    if (attendedCollege === "No") {
      let updatedInstitute = institutionsAttended.filter(
        (instAtt) => instAtt.educationlevelid !== 2,
      );
      if (isCollegeUser()) {
        setCurrEnrolled("");
        setYearEnrolled("");
      }
      let body = [];
      updatedInstitute.forEach((instAtt) => {
        if (instAtt.educationHistoryId) {
          body.push({
            candidateid: props.candidateId,
            educationhistoryid: instAtt.educationHistoryId,
          });
        }
        if (instAtt.interneducationhistoryid) {
          body.push({
            candidateid: props.candidateId,
            interneducationhistoryid: instAtt.interneducationhistoryid,
          });
        }
      });
      if (body.length > 0 && isCareerUser()) {
        setLoading(true);
        await updateCandidateEducation(props.subId, body);
        setLoading(false);
      } else if (body.length > 0 && isCollegeUser()) {
        setLoading(true);
        await updateInternEducation(props.subId, body);
        setLoading(false);
        props.saveInternEduInfo(
          institutionsAttended.filter((inst) => inst.educationlevelid === 2),
        );
      }
      setInstitutionsAttended(
        institutionsAttended.filter((inst) => inst.educationlevelid === 2),
      );
      props.savePartialEduInfo(
        institutionsAttended.filter((inst) => inst.educationlevelid === 2),
      );

      setShowBackModal(false);
      if (attendedCollege === "No" && prevAttendedCollege.current === "Yes") {
        setAttendedCollege("Yes");
      }
      setAttendedCollege("No");
      if (!isBackClicked) return;
    }

    handleCloseBackModal();
    setTimeout(() => {
      if (isBackClicked) {
        props.hasCurrentFormChanged(false);
        props.isFormComplete(true);
      }
    }, 10);

    if (props.contracttypedesc === CONTRACT_TYPE_DESCRIPTIONS.COLLEGE_INTERN) {
      props.toggleForm(FORM_ID.RESIDENTIAL_HISTORY);
    } else if (
      props.contracttypedesc === CONTRACT_TYPE_DESCRIPTIONS.CRIA_ONLY ||
      props.contracttypedesc === CONTRACT_TYPE_DESCRIPTIONS.INVESTMENT_ADVISOR
    ) {
      props.toggleForm(FORM_ID.PERSONAL_INFO);
    } else {
      props.toggleForm(FORM_ID.BUSINESS_INFO);
    }
  };

  const handleShowBackModal = () => {
    if (formHasChanged) {
      setIsBackClicked(true);
      setShowBackModal(true);
    } else {
      props.saveEduInfo(institutionsAttended);
      if (
        props.contracttypedesc === CONTRACT_TYPE_DESCRIPTIONS.COLLEGE_INTERN
      ) {
        props.toggleForm(FORM_ID.RESIDENTIAL_HISTORY);
      } else if (
        props.contracttypedesc === CONTRACT_TYPE_DESCRIPTIONS.CRIA_ONLY ||
        props.contracttypedesc === CONTRACT_TYPE_DESCRIPTIONS.INVESTMENT_ADVISOR
      ) {
        props.toggleForm(FORM_ID.PERSONAL_INFO);
      } else {
        props.toggleForm(FORM_ID.BUSINESS_INFO);
      }
    }
  };

  const getYearId = (yearId) => {
    switch (yearId) {
      case 1:
        return "Junior";
      case 2:
        return "Senior";
      case 3:
        return "Graduate Program";
      default:
        return "";
    }
  };

  const hasBasicField =
    institutionName?.length > 2 &&
    startDate?.length > 2 &&
    endDate?.length > 2 &&
    city?.length > 1 &&
    country?.length > 0 &&
    (country === "US" ? state.length > 0 : true) &&
    !formHasError;

  const isNextDisable = () => {
    const highEducation =
      institutionsAttended.filter((inst) => inst.educationlevelid !== 2)
        .length > 0;
    if (formHasError) return true;
    const needsState = country === "US" && state?.length > 0;
    const noCollegeAttended =
      attendedCollege === "No" &&
      hasBasicField &&
      (country !== "US" || needsState);
    const collegeAttended = attendedCollege === "Yes" && highEducation;
    if (isCollegeUser() && attendedCollege === "Yes") {
      if (currEnrolled === "Yes" && yearEnrolled !== "" && highEducation) {
        return false;
      } else {
        return true;
      }
    }

    return !(noCollegeAttended || collegeAttended);
  };

  const handleShowEduReqModal = () => {
    setShowEduReqModal(true);
  };

  const handleCloseEduReqModal = () => {
    setShowEduReqModal(false);
    setCurrEnrolled("Yes");
  };

  const handleBackEduClick = () => {
    handleCloseEduReqModal();
    window.location = "/";
  };

  const closeAddInstitutionModal = (modalToggle) => {
    setShowAddInstitutionModal(modalToggle);
  };

  const handleChange = (event) => {
    hasChange = true;
    // event.target.id === "attendedCollegeNo"
    //   ? props.hasCurrentFormChanged(false)
    //   : props.hasCurrentFormChanged(true);
    props.hasCurrentFormChanged(true);
    props.isFormComplete(false);
    if (event.target.id === "education_id") {
      setHighestEducationId(event.target.value);
      setHighestEducation(event.target.innerText);

      if (
        event.target.innerText === "Attended College - No Degree" ||
        event.target.innerText ===
          "Completed secondary education (Graduated High School)"
      ) {
        setDisableMajorIn(true);
        setMajorIn("");
      } else {
        setDisableMajorIn(false);
      }
    }

    if (event.target.id === "country_id") {
      if (event.target.value === "US") {
        setShowState(true);
      } else {
        setShowState(false);
        setState("");
        let obj_error = document.getElementById("state_id_error");
        obj_error.style.display = "none";
        let ctrlToValidate = document.getElementById("state_id_opt");
        ctrlToValidate.removeAttribute("style");
      }
      setCountry(event.target.value);
    }

    if (event.target.id.includes("collegeEnrolled")) {
      var obj_error = document.getElementById("collegeEnrollError");
      setCurrEnrolled(event.target.value);

      obj_error = document.getElementById("collegeEnrollFillError");
      let collegeEnrolledYes = document.getElementById("collegeEnrolledYes");
      collegeEnrolledYes.classList.remove("is-invalid");
      let collegeEnrolledNes = document.getElementById("collegeEnrolledNo");
      collegeEnrolledNes.classList.remove("is-invalid");
      obj_error.style.display = "none";
      hasError = false;

      if (event.target.value !== "Yes") {
        handleShowEduReqModal();
        obj_error.style.display = "block";
        document.getElementById("collegeEnrollFillError").style.display =
          "none";
        hasError = true;
      } else if (event.target.value === "Yes") {
        obj_error.style.display = "none";
        document.getElementById("collegeEnrollFillError").style.display =
          "none";
        hasError = false;
        setLoading(false);
      }
    }

    if (event.target.id.includes("attendedCollege")) {
      setAttendedCollege(event.target.value);

      obj_error = document.getElementById("collegeEnrollFillError");
      let currentlyMilitaryYes = document.getElementById("attendedCollegeYes");
      currentlyMilitaryYes.classList.remove("is-invalid");
      let currentlyMilitaryNo = document.getElementById("attendedCollegeNo");
      currentlyMilitaryNo.classList.remove("is-invalid");
      obj_error.style.display = "none";
      hasError = false;

      if (event.target.value !== "Yes") {
        let instLength = institutionsAttended.filter(
          (inst) => inst.educationlevelid !== 2,
        ).length;
        if (instLength > 0) {
          setShowBackModal(true);
        }
        if (isCollegeUser() && instLength === 0) {
          setCurrEnrolled("");
          setYearEnrolled("");
        }
        obj_error.style.display = "block";
        document.getElementById("collegeEnrollFillError").style.display =
          "none";
        hasError = true;
      } else if (event.target.value === "Yes") {
        obj_error.style.display = "none";
        document.getElementById("collegeEnrollFillError").style.display =
          "none";
        hasError = false;
        setLoading(false);
      }
    }

    if (event.target.id.includes("yearEnrolled")) {
      setYearEnrolled(event.target.value);
      obj_error = document.getElementById("collegeYearError");
      let yearEnrolledJunior = document.getElementById("yearEnrolledJunior");
      yearEnrolledJunior.classList.remove("is-invalid");
      let yearEnrolledSenior = document.getElementById("yearEnrolledSenior");
      yearEnrolledSenior.classList.remove("is-invalid");
      let yearEnrolledGrad = document.getElementById("yearEnrolledGrad");
      yearEnrolledGrad.classList.remove("is-invalid");
      obj_error.style.display = "none";
      hasError = false;
    }

    if (event.target.id === "overallGpa") {
      setOverallGpa(event.target.value.replace(/_/g, ""));
    }

    if (event.target.id === "majorGpa") {
      setMajorGpa(event.target.value.replace(/_/g, ""));
    }

    if (event.target.id === "state_id_opt") {
      setState(event.target.value);
    }
    if (event.target.id === "city") {
      setCity(event.target.value);
    }
    if (event.target.id === "major_in") {
      setMajorIn(event.target.value);
    }
    if (event.target.id === "institution_name") {
      setInstitutionName(event.target.value);
    }
    if (event.target.id === "degree_name") {
      setDegreeId(event.target.value);
      setDegree(event.target.innerText);
    }
    if (event.target.id === "start_date") {
      setStartDate(event.target.value);
    }
    if (event.target.id === "end_date") {
      setEndDate(event.target.value);
    }
    setFormHasChanged(true);
    props.hasCurrentFormChanged(true);
  };

  const instituteDetailsBody = (instituteInfo) => {
    const body = [];
    instituteInfo.forEach((info) => {
      const {
        institution_Name,
        majorIn,
        start_Date,
        end_Date,
        city,
        state,
        country,
        educationlevelid,
        educationdegreeid,
        educationHistoryId,
        degree,
        currentInstitutionCheck,
        interneducationhistoryid,
      } = info;

      if (isCollegeUser()) {
        let academicYearId;
        switch (yearEnrolled) {
          case "Junior":
            academicYearId = 1;
            break;
          case "Senior":
            academicYearId = 2;
            break;
          case "Graduate Program":
            academicYearId = 3;
            break;
          default:
            academicYearId = null;
        }
        body.push({
          candidateid: props.candidateId,
          currentacademicyearid: academicYearId,
          educationdegreeid: educationdegreeid,
          educationlevelid: educationlevelid,
          interneducationhistoryid: interneducationhistoryid
            ? interneducationhistoryid
            : null,
          fulltimeenrolled: currEnrolled,
          institutionname: institution_Name,
          currentlyattending: currentInstitutionCheck,
          city: city,
          state: state,
          country: country,
          enrolldate: start_Date,
          expectgraddate: end_Date,
          degreeseeking: degree || "",
          major: majorIn,
        });
      }
      if (isCareerUser()) {
        body.push({
          candidateid: props.candidateId,
          educationlevelid: educationlevelid,
          educationdegreeid: educationdegreeid,
          educationhistoryid: educationHistoryId ? educationHistoryId : null,
          major: majorIn || "",
          institutionname: institution_Name,
          startdate: start_Date,
          enddate: end_Date,
          city: city,
          state: state,
          country: country,
          currentinstitution: currentInstitutionCheck
            ? currentInstitutionCheck
            : false,
        });
      }
    });
    return body;
  };

  const onKeyDown = (event) => {
    if (
      event.target.id !== "education_id" &&
      event.target.id !== "degree_name" &&
      event.target.id !== "state_id_opt" &&
      event.target.id !== "country_id"
    ) {
      props.isFormComplete(false);
    }
  };

  const onFocusState = () => {
    setCntrlWithFocus("");
    let inputs = document.querySelectorAll("button, a");
    try {
      for (let i = 0; i < inputs.length; ++i) {
        inputs[i].addEventListener("focusout", (event) => {
          if (event.relatedTarget == null) {
            setCntrlWithFocus("");
          } else {
            setCntrlWithFocus(event.relatedTarget.id);
          }
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleNext = async () => {
    const details = {
      candidateid: props.candidateId,
      educationlevelid: 2,
      educationdegreeid: 110,
      majorIn: majorIn,
      institution_Name: institutionName,
      start_Date: startDate,
      end_Date: endDate,
      city: city,
      state: state,
      country: country,
    };

    if (isCareerUser()) {
      const isHighSchoolInfo = institutionsAttended.some(
        (data) => data.educationlevelid === 2,
      );
      let updatedInstitute = institutionsAttended;
      if (isHighSchoolInfo) {
        updatedInstitute = institutionsAttended.map((inst) =>
          inst.educationlevelid === 2 ? { ...inst, ...details } : inst,
        );
      } else {
        updatedInstitute = [...institutionsAttended, details];
      }
      let body = instituteDetailsBody(updatedInstitute);
      setLoading(true);
      const { data } = await insertCandidateEducation(props.subId, body);
      if (data.response.length > 0) {
        props.saveEduInfo(data.response);
        props.isFormComplete(true);
      }
      setLoading(false);
    }
    if (isCollegeUser()) {
      if (currEnrolled === "No" || attendedCollege === "No") {
        handleShowEduReqModal();
        return;
      }
      if (currEnrolled !== "Yes") {
        var obj_error = document.getElementById("collegeEnrollFillError");
        let currentlyMilitaryYes =
          document.getElementById("collegeEnrolledYes");
        currentlyMilitaryYes.classList.add("is-invalid");
        let currentlyMilitaryNo = document.getElementById("collegeEnrolledNo");
        currentlyMilitaryNo.classList.add("is-invalid");
        obj_error.style.display = "block";
        let label_yes = document.getElementById("label_collegeEnrolledYes");
        label_yes.style.color = "#555";
        let label_no = document.getElementById("label_collegeEnrolledNo");
        label_no.style.color = "#555";
        hasError = true;

        return;
      }
      if (currEnrolled === "Yes") {
        obj_error = document.getElementById("collegeYearError");
        if (yearEnrolled === "") {
          let yearEnrolledJunior =
            document.getElementById("yearEnrolledJunior");
          yearEnrolledJunior.classList.add("is-invalid");
          let yearEnrolledSenior =
            document.getElementById("yearEnrolledSenior");
          yearEnrolledSenior.classList.add("is-invalid");
          let yearEnrolledGrad = document.getElementById("yearEnrolledGrad");
          yearEnrolledGrad.classList.add("is-invalid");
          obj_error.style.display = "block";
          let label_yearEnrolledJunior = document.getElementById(
            "label_yearEnrolledJunior",
          );
          label_yearEnrolledJunior.style.color = "#555";
          let label_yearEnrolledSenior = document.getElementById(
            "label_yearEnrolledSenior",
          );
          label_yearEnrolledSenior.style.color = "#555";
          let label_yearEnrolledGrad = document.getElementById(
            "label_yearEnrolledGrad",
          );
          label_yearEnrolledGrad.style.color = "#555";
          hasError = true;
        } else if (yearEnrolled !== "") {
          obj_error.style.display = "none";
          hasError = false;
        }
      }

      const isHighSchoolInfo = institutionsAttended.some(
        (data) => data.educationlevelid === 2,
      );
      let updatedInstitute = institutionsAttended;
      if (isHighSchoolInfo) {
        updatedInstitute = institutionsAttended.map((inst) =>
          inst.educationlevelid === 2 ? { ...inst, ...details } : inst,
        );
      } else {
        updatedInstitute = [...institutionsAttended, details];
      }
      let body = instituteDetailsBody(updatedInstitute);
      setLoading(true);
      const { data } = await insertInternEducation(props.subId, body);
      if (data.response.length > 0) {
        props.saveInternEduInfo(data.response);
      }
      setLoading(false);
    }

    if (formHasError === false && formHasChanged === true && !hasError) {
      setLoading(true);

      props.hasCurrentFormChanged(false);

      setFormHasChanged(false);
      props.hasCurrentFormChanged(false);
      props.isFormComplete(true);
      hasChange = false;
      setLoading(false);
    }
    if (!hasChange && !hasError) {
      if (
        props.contracttypedesc === CONTRACT_TYPE_DESCRIPTIONS.CRIA_ONLY ||
        props.contracttypedesc === CONTRACT_TYPE_DESCRIPTIONS.INVESTMENT_ADVISOR
      ) {
        props.toggleForm(FORM_ID.PROFESSIONAL_DESIGNATION_CRIA);
      } else {
        props.toggleForm(FORM_ID.PROFESSIONAL_DESIGNATION);
      }
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      let data = {};
      let degrees = props.eduDegrees;
      let educationlevel = props.eduLevels;

      setDEGREES(degrees);
      setEDUCATIONLEVEL(educationlevel);
      setFormHasError(false);

      if (isCollegeUser()) {
        if (props.internEduData.length > 0) {
          mapInstituteDatatoState(props.internEduData);
        }
      } else if (isCareerUser()) {
        if (props.eduData.length > 0) {
          mapInstituteDatatoState(props.eduData);
        }
      }
      return data;
    };

    const mapInstituteDatatoState = (data) => {
      let degrees = props.eduDegrees;
      setDEGREES(degrees);

      data.forEach((education, index) => {
        let degObj = degrees.find(
          (o) => o.educationdegreeid === education.educationdegreeid,
        );
        if (education.educationlevelid === 2) {
          setCity(education.city || "");
          setState(education.state || "");
          setCountry(education.country || "");
          setInstitutionName(
            education.institutionname
              ? education.institutionname
              : education.institution_Name || "",
          );
          setMajorIn(education.major || "");
          if (education.fulltimeenrolled) setCurrEnrolled("Yes");
          // setYearEnrolled(getYearId(education.currentacademicyearid));
          if (
            isCollegeUser() &&
            education.enrolldate &&
            education.expectgraddate
          ) {
            setStartDate(education.enrolldate || "");
            setEndDate(education.expectgraddate || "");
          } else {
            setStartDate(
              education.startdate
                ? education.startdate
                : education.start_Date || "",
            );
            setEndDate(
              education.enddate ? education.enddate : education.end_Date || "",
            );
          }
        }
        data.length > 1 && setAttendedCollege("Yes");
        if (isCollegeUser()) data.length > 1 && setCurrEnrolled("Yes");
        data.length === 1 &&
          education.educationlevelid === 2 &&
          setAttendedCollege("No");
        if (isCollegeUser() && data.length === 1) {
          education.educationlevelid === 2 && setCurrEnrolled("");
        }
        if (isCollegeUser() && data.length > 1) {
          setYearEnrolled(getYearId(education.currentacademicyearid));
        }
        setInstitutionsAttended((prev) => {
          if (isCollegeUser()) {
            education.startdate = education.enrolldate
              ? education.enrolldate
              : education.startdate;
            education.enddate = education.expectgraddate
              ? education.expectgraddate
              : education.enddate;
            education.currentinstitution = education.currentlyattending;
          }
          return [
            ...prev,
            {
              interneducationhistoryid: education.interneducationhistoryid,
              educationHistoryId: education.educationhistoryid
                ? education.educationhistoryid
                : education.educationHistoryId,
              id: index,
              institution_Name: education.institutionname
                ? education.institutionname
                : education.institution_Name || "",
              start_Date: education.startdate
                ? education.startdate
                : education.start_Date || "",
              end_Date: education.enddate
                ? education.enddate
                : education.end_Date || "",
              city: education.city || "",
              state: education.state || "",
              country: education.country || "",
              currentInstitutionCheck: education.currentinstitution
                ? education.currentinstitution
                : education.currentInstitutionCheck || false,
              majorIn: education.major
                ? education.major
                : education.majorIn || "",
              degree: degObj?.educationdegreedesc || "",
              educationdegreeid: education.educationdegreeid || null,
              educationlevelid: education.educationlevelid || "",
              currentacademicyearid: education.currentacademicyearid || null,
            },
          ];
        });
      });
    };

    fetchData();
    UtagTracking.sendPageNameView(
      "educationform",
      props.candidateId,
      props.agencynumber,
      props.contracttypeid,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (prevAttendedCollege.current === "Yes" && attendedCollege === "No") {
      prevAttendedCollege.current = "Yes";
    } else {
      prevAttendedCollege.current = attendedCollege;
    }
  }, [attendedCollege]);

  const addInstitutionData = async (institutionDetail) => {
    setInstitutionsAttended((prev) => {
      const lastId = institutionsAttended.length - 1;
      const newId = lastId + 1;
      return [...prev, { ...institutionDetail, id: newId }];
    });
    setFormHasChanged(true);
    props.hasCurrentFormChanged(true);
  };

  const deleteData = async (institute) => {
    let updatedInstitute = institutionsAttended.filter((inst) => {
      const same = (a, b) => a != null && b != null && String(a) === String(b);
      const KEYS = [
        "interneducationhistoryid",
        "educationHistoryId",
        "educationhistoryid",
        "id",
      ];
      const isMatch = KEYS.some((k) => same(inst[k], institute[k]));
      return isMatch ? false : true;
    });
    if (institute.educationHistoryId) {
      let body = {
        candidateid: props?.candidateId,
        educationhistoryid: institute.educationHistoryId,
      };
      setLoading(true);
      await updateCandidateEducation(props.subId, [body]);
      setLoading(false);
    }
    if (institute.interneducationhistoryid) {
      let body = {
        candidateid: props?.candidateId,
        interneducationhistoryid: institute.interneducationhistoryid,
      };
      setLoading(true);
      await updateInternEducation(props.subId, [body]);
      setLoading(false);
    }
    setInstitutionsAttended(updatedInstitute);
    if (isCareerUser()) props.saveEduInfo(updatedInstitute);
    if (isCollegeUser()) props.saveInternEduInfo(updatedInstitute);
    props.hasCurrentFormChanged(true);
    props.isFormComplete(false);
    setFormHasChanged(true);
  };

  const handleEditInstitute = (instituteInfo) => {
    let selectedInstituteDetails = institutionsAttended.filter((inst) => {
      const same = (a, b) => a != null && b != null && String(a) === String(b);
      const KEYS = [
        "interneducationhistoryid",
        "educationHistoryId",
        "educationhistoryid",
        "id",
      ];
      const isMatch = KEYS.some((k) => same(inst[k], instituteInfo[k]));
      return isMatch ? true : false;
    });
    setEditInstitutionDetails(selectedInstituteDetails);
    setIsReviewEditInstitution(true);
    setShowAddInstitutionModal(true);
  };

  const handleToggle = () => {
    const dropdownMenu = document.querySelector(".dropdown-menu.show");
    if (dropdownMenu) {
      dropdownMenu.scrollTop = 0;
    }
  };

  const updateInstituteData = async (instituteInfo) => {
    const same = (a, b) => a != null && b != null && String(a) === String(b);
    const KEYS = [
      "interneducationhistoryid",
      "educationHistoryId",
      "educationhistoryid",
      "id",
    ];
    setInstitutionsAttended((prev) =>
      prev.map((attended) => {
        const isMatch = KEYS.some((k) => same(attended[k], instituteInfo[k]));
        return isMatch ? { ...attended, ...instituteInfo } : attended;
      }),
    );
    setEditInstitutionDetails([]);
  };

  return (
    <div>
      <div className="row">
        <div className="col-md-12">
          <h1>Education</h1>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <span className="required-field-text">* = Required Field</span>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12" style={{ paddingTop: "15px" }}>
          <h3>Provide your education information.</h3>
        </div>
      </div>

      {(isCareerUser() || isCollegeUser()) && (
        <>
          <div className="row">
            <div className="col-md-12" style={{ paddingTop: "15px" }}>
              <h3>What was your last High School attended?</h3>
            </div>
          </div>
          <div
            className="row"
            style={{
              paddingTop: "20px",
            }}
          >
            <div className="col">
              <label htmlFor="institution_name">
                <strong>High School Name*</strong>
              </label>
              <input
                type="text"
                id="institution_name"
                className="form-control form-control form-control-15"
                maxLength={100}
                minLength={3}
                value={institutionName}
                onBlur={onBlur}
                onChange={handleChange}
                onKeyDown={onKeyDown}
                autoComplete="off"
              ></input>
              <div id="institution_name_error" className="invalid-feedback">
                Please enter the High School Name
              </div>
            </div>
          </div>
          <div style={{ paddingTop: "20px" }}>
            <strong>What dates did you attend?*</strong>
          </div>

          <div
            className="row"
            style={{
              paddingTop: "20px",
            }}
          >
            <div className="col">
              <label htmlFor="start_date">
                <strong> Start Date* </strong>
              </label>

              <InputMask
                id="start_date"
                mask="99/9999"
                maskChar="_"
                className="form-control"
                placeholder="MM/YYYY"
                value={startDate}
                onBlur={onBlur}
                onChange={handleChange}
                onKeyDown={onKeyDown}
                required
                autoComplete="off"
              />

              <div id="start_date_error" className="invalid-feedback">
                Please enter a Start Date
              </div>
            </div>
            <div className="col">
              <label htmlFor="end_date">
                <strong> End Date* </strong>
              </label>

              <InputMask
                id="end_date"
                mask="99/9999"
                maskChar="_"
                className="form-control"
                placeholder="MM/YYYY"
                value={endDate}
                onBlur={onBlur}
                onChange={handleChange}
                onKeyDown={onKeyDown}
                required
                autoComplete="off"
              />

              <div id={"end_date_error"} className="invalid-feedback">
                Please enter an End Date
              </div>
            </div>
          </div>
          <div className="row" style={{ paddingTop: "20px" }}>
            <div className="col">
              <label htmlFor="city" aria-label="City">
                <strong>City*</strong>
              </label>
              <input
                type="text"
                id="city"
                className="form-control form-control form-control-15"
                maxLength={100}
                minLength={2}
                value={city}
                onBlur={onBlur}
                onChange={handleChange}
                aria-label="City"
                onKeyDown={onKeyDown}
                autoComplete="off"
              />
              <div id="city_error" className="invalid-feedback">
                Please enter a City
              </div>
            </div>
          </div>
          <div className="row" style={{ paddingTop: "20px" }}>
            <div className="col">
              <label>
                <strong>
                  State/Province
                  {country === "US" ? "*" : ""}
                </strong>
              </label>

              <DropdownButton
                id="state_id_opt"
                type="default"
                variant="secondary"
                title={state || "\u00A0"}
                selected={false}
                autoComplete="new-address"
                onSelect={(key, event) => {
                  event.target.id = "state_id_opt";
                  event.target.value = key;
                  handleChange(event);
                }}
                onBlur={onBlur}
                onClick={clickFunc}
                onFocus={onFocusState}
                onToggle={handleToggle}
                required
              >
                {STATES.map((state, index) => {
                  return (
                    <div key={index}>
                      <Dropdown.Item eventKey={state.code} id="state_option">
                        {state.code + " - " + state.name}
                      </Dropdown.Item>
                    </div>
                  );
                })}
              </DropdownButton>
              <div id={"state_id_error"} className="invalid-feedback">
                Please choose State/Province
              </div>
            </div>
          </div>
          <div className="row" style={{ paddingTop: "20px" }}>
            <div className="col">
              <label htmlFor="country_id">
                <strong>Country*</strong>
              </label>
              <DropdownButton
                id={"country_id"}
                type="default"
                variant="secondary"
                title={country || "\u00A0"}
                selected={false}
                autoComplete="new-address"
                onSelect={(key, event) => {
                  event.target.id = "country_id";
                  event.target.value = key;
                  handleChange(event);
                }}
                onBlur={onBlur}
                onClick={clickFunc}
                onFocus={onFocusState}
                required
              >
                {COUNTRIES.map((country, index) => {
                  return (
                    <div key={index}>
                      <Dropdown.Item
                        eventKey={country.code}
                        id="country_option"
                      >
                        {country.code + " - " + country.name}
                      </Dropdown.Item>
                    </div>
                  );
                })}
              </DropdownButton>
              <div id={"country_id_error"} className="invalid-feedback">
                Please choose a Country
              </div>
            </div>
          </div>
          <div className="row" style={{ paddingTop: "20px" }}>
            <div className="col-md-12">
              <strong>
                Did you attend any institutions after High School?*
              </strong>
            </div>
          </div>

          <div className="row">
            <div className="custom-control">
              <div className="col-12 copy-md-8" style={{ paddingTop: "10px" }}>
                <div className="custom-control custom-radio">
                  <input
                    name="radio-guide-attended-college"
                    type="radio"
                    id="attendedCollegeYes"
                    className="custom-control-input"
                    value="Yes"
                    onChange={handleChange}
                    checked={attendedCollege === "Yes"}
                    required
                    disabled={!hasBasicField}
                  />
                  <label
                    htmlFor="attendedCollegeYes"
                    className="custom-control-label"
                    id="label_collegeEnrolledYes"
                  >
                    Yes
                  </label>
                </div>
                <div className="custom-control custom-radio">
                  <input
                    name="radio-guide-attended-college"
                    type="radio"
                    id="attendedCollegeNo"
                    className="custom-control-input"
                    value="No"
                    onChange={handleChange}
                    checked={attendedCollege === "No"}
                    required
                    disabled={!hasBasicField}
                  />
                  <label
                    htmlFor="attendedCollegeNo"
                    className="custom-control-label"
                    id="label_attendedCollegeNo"
                  >
                    No
                  </label>
                </div>
              </div>
              <div id="collegeEnrollFillError" className="invalid-feedback">
                Please choose a response
              </div>
            </div>
          </div>

          {attendedCollege === "Yes" && hasBasicField && (
            <>
              {isCollegeUser() && (
                <>
                  <hr />
                  <div className="row">
                    <div className="col-md-12">
                      <strong>
                        Are you currently enrolled full time in college?*
                      </strong>
                    </div>
                  </div>

                  <div className="row">
                    <div className="custom-control">
                      <div
                        className="col-12 copy-md-8"
                        style={{ paddingTop: "10px" }}
                      >
                        <div className="custom-control custom-radio">
                          <input
                            name="radio-guide-enrolled"
                            type="radio"
                            id="collegeEnrolledYes"
                            className="custom-control-input"
                            value="Yes"
                            onChange={handleChange}
                            checked={currEnrolled === "Yes"}
                            required
                          />
                          <label
                            htmlFor="collegeEnrolledYes"
                            className="custom-control-label"
                            id="label_collegeEnrolledYes"
                          >
                            Yes
                          </label>
                        </div>
                        <div className="custom-control custom-radio">
                          <input
                            name="radio-guide-enrolled"
                            type="radio"
                            id="collegeEnrolledNo"
                            className="custom-control-input"
                            value="No"
                            onChange={handleChange}
                            checked={currEnrolled === "No"}
                            required
                          />
                          <label
                            htmlFor="collegeEnrolledNo"
                            className="custom-control-label"
                            id="label_collegeEnrolledNo"
                          >
                            No
                          </label>
                        </div>
                        <div
                          id="collegeEnrollError"
                          className="invalid-feedback"
                        >
                          Education Requirements Not Met
                        </div>
                        <div
                          id="collegeEnrollFillError"
                          className="invalid-feedback"
                        >
                          Please choose a response
                        </div>
                      </div>
                    </div>
                  </div>
                  {isCollegeUser() && currEnrolled === "Yes" && (
                    <>
                      <div className="row">
                        <div className="col">
                          <strong>
                            What academic year are you currently enrolled in?*
                          </strong>
                        </div>
                      </div>
                      <div className="row">
                        <div className="custom-control">
                          <div
                            className="col-12 copy-md-8"
                            style={{ paddingTop: "10px" }}
                          >
                            <div className="custom-control custom-radio">
                              <input
                                name="radio-guide-year"
                                type="radio"
                                id="yearEnrolledJunior"
                                className="custom-control-input"
                                value="Junior"
                                onChange={handleChange}
                                checked={yearEnrolled === "Junior"}
                                required
                              />
                              <label
                                htmlFor="yearEnrolledJunior"
                                className="custom-control-label"
                                id="label_yearEnrolledJunior"
                              >
                                Junior
                              </label>
                            </div>
                            <div className="custom-control custom-radio">
                              <input
                                name="radio-guide-year"
                                type="radio"
                                id="yearEnrolledSenior"
                                className="custom-control-input"
                                value="Senior"
                                onChange={handleChange}
                                checked={yearEnrolled === "Senior"}
                                required
                              />
                              <label
                                htmlFor="yearEnrolledSenior"
                                className="custom-control-label"
                                id="label_yearEnrolledSenior"
                              >
                                Senior
                              </label>
                            </div>
                            <div className="custom-control custom-radio">
                              <input
                                name="radio-guide-year"
                                type="radio"
                                id="yearEnrolledGrad"
                                className="custom-control-input"
                                value="Graduate Program"
                                onChange={handleChange}
                                checked={yearEnrolled === "Graduate Program"}
                                required
                              />
                              <label
                                htmlFor="yearEnrolledGrad"
                                className="custom-control-label"
                                id="label_yearEnrolledGrad"
                              >
                                Graduate Program
                              </label>
                            </div>
                            <div
                              id="collegeYearError"
                              className="invalid-feedback"
                            >
                              Please choose a response
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </>
              )}
              <hr />
              <div className="row">
                <div className="col-md-12" style={{ paddingTop: "15px" }}>
                  <h3>Post High School Education</h3>
                </div>
              </div>
              <label htmlFor="initialAddHistory" aria-label="City">
                If you answered "Yes", you must add institution details.
              </label>
              <div className="row residential-history-grid">
                <div className="col-md-12">
                  <div style={{ padding: "24px" }}>
                    <div
                      style={{ maxWidth: "200px", cursor: "pointer" }}
                      onClick={() => setShowAddInstitutionModal()}
                      id="initialAddHistory"
                    >
                      <span
                        className="icon-add"
                        style={{ marginRight: "10px" }}
                      ></span>
                      <strong style={{ color: "#004db2" }}>
                        Add Institution Details
                      </strong>
                    </div>
                  </div>
                  <hr />
                  <InstitutionHistoryTable
                    data={institutionsAttended.filter(
                      (instAtt) => instAtt.educationlevelid !== 2,
                    )}
                    show_modal={showEduReqModal}
                    deleteData={deleteData}
                    reviewEditClick={handleEditInstitute}
                  />
                </div>
              </div>
            </>
          )}
        </>
      )}

      <InstitutionModal
        showAddInstitutionModal={showAddInstitutionModal}
        addData={addInstitutionData}
        DEGREES={DEGREES}
        closeAddInstitutionModal={closeAddInstitutionModal}
        onKeyDown={onKeyDown}
        handleToggle={handleToggle}
        editInstitutionDetails={editInstitutionDetails}
        updateInstituteData={updateInstituteData}
        isReviewEditInstitution={isReviewEditInstitution}
        setIsReviewEditInstitution={setIsReviewEditInstitution}
        setEditInstitutionDetails={setEditInstitutionDetails}
      />

      <NavigationButtons
        onBack={handleShowBackModal}
        onNext={handleNext}
        isLoading={loading}
        nxtbtnid={"nxtedubtn"}
        bckbtnid={"edubckbtn"}
        isDisabled={isNextDisable()}
      />

      <LostDataModal
        isOpen={showBackModal}
        handleClose={handleCloseBackModal}
        handleProceed={handleLostDataProceed}
      />

      <EducationRequirementsModal
        isOpen={showEduReqModal}
        closeBackModal={handleCloseEduReqModal}
        backClick={handleBackEduClick}
      />
    </div>
  );
};

export default EducationForm;
